import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DigitalGatewayToKerala() {
  return <section data-section-id="230148" id="own-the-mailbox-in-metro-atlanta" className="relative overflow-hidden bg-background text-foreground pt-24 pb-16 lg:pt-32 lg:pb-24">
      {}
      <div className="absolute inset-0 z-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/atlanta_metro_map_watermark.png)] bg-cover bg-center pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col justify-center text-center lg:text-left">
            <h1 className="font-default text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl mb-6">
              <span className="bg-gradient-to-r from-secondary to-secondary/80 bg-clip-text text-transparent">
                Own the Mailbox
              </span>
              <br />
              in Metro Atlanta
            </h1>
            
            <p className="font-default text-lg text-muted-foreground mb-8 max-w-[600px] mx-auto lg:mx-0 leading-relaxed">
              Reach 2,500+ high-income households with premium, oversized co-op postcards. 
              Exclusive placement for your business category in Johns Creek and beyond.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <Button size="lg" asChild className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
                <Link to="/ContactPage">Claim Your Spot</Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto border-secondary text-secondary hover:bg-secondary/5">
                <Link to="/CoveragePage">
                  <Play className="mr-2 size-4" />
                  View Coverage
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative flex items-center justify-center min-h-[400px] lg:min-h-[500px] mt-8 lg:mt-0">
            
            {}
            <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl opacity-30 scale-110 pointer-events-none" />

            {}
            <div className="relative w-full max-w-[280px] sm:max-w-[320px] aspect-[9/16] z-20">
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/premium_postcard_3d_render.png" alt="Premium Oversized Postcard Render" className="absolute inset-0 w-full h-full object-contain drop-shadow-4xl z-20" />

              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/johns_creek_neighborhood_badge.png" alt="Johns Creek Coverage Area" className="absolute -left-16 top-20 w-32 md:w-40 rounded-md shadow-xl z-10 -rotate-12 transition-transform duration-700 hover:-translate-y-2 hover:-rotate-6" />

              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/usps_eddm_tracking_qr.png" alt="QR Code Tracking Feature" className="absolute -right-12 bottom-24 w-28 md:w-36 rounded-md shadow-xl z-30 rotate-6 transition-transform duration-700 hover:-translate-y-2 hover:rotate-12" />
              
            </div>
          </div>

        </div>
      </div>
    </section>;
}